$(document).ready(function() {

  //Toggle the display of events on the create_edit user page
  if ($("#userAdd").length) {
    toggleEventlist();
    $("#role-id").change(function(){
      toggleEventlist();
    })
  }
  function toggleEventlist(){
    if($("#role-id").val()==6){
      $('#event-list').show();
    }else{
      $('#event-list').hide()
    }
  }
});
